const buttonConfirmTenant = {
  text: 'Adicionar acesso'
};

export default buttonConfirmTenant;
